import { t } from 'i18next';
import React, { useState, useEffect, useRef } from 'react'
import { CheckBox } from '../../../../components/controls/checkbox';
import GridMultipleSelectorInputV2 from '../../../../components/controls/GridMultipleSelectorInputV2';
import GridWrapper from '../../../../components/controls/GridWrapper';
import { NumberInput, TextInput } from '../../../../components/controls/inputs';
import { DefaultGrid } from '../../../../components/grids/default/defaultGrid';
import { PluginWrapper } from '../../../../components/plugins';
import { IEntitySimpleDTO } from '../../../../libs/coreapi-dto/@types/common';
import useGridFilter from '../../../../system/hooks/useGridFilter';
import { StoreSelectorModal } from '../../../Dictionaries/Store';
import { Button } from '../../../../components/buttons/button';
import { v4 as uuidv4 } from 'uuid';
import { StoreDataProvider } from '../../../../Services/DataProviders/StoreDataProvider';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { AuthDataDataProvider } from '../../../../Services/DataProviders/AuthDataDataProvider';
import { IAuthDataViewDTO } from '../../../../libs/coreapi-dto/service/authData';
import { ConnectionSettingsF3lloPlugin } from '../pluginSettings/ConnectionSettingsF3lloPlugin';
import BaseCommandsPanel from '../../../../components/commandsPanels/BaseCommandsPanel';
import { Delete2Button } from '../../../../components/buttons/iconButtons/action/MainCollection';
import Tooltip from '../../../../components/tooltips/Tooltip';
import { IStoreSendRemain, IStoreSendRemains } from '../../../../libs/coreapi-dto/dirs/store';
import styles from '../styles/ConnectionSettingsF3llo.module.scss';
import { LoadingStatus } from '../../../../@types/enumsGlobal';
import { SysOptionsDataProvider } from '../../../../Services/DataProviders/SysOptionsDataProvider';
import { ISysOptionsDTO } from '../../../../libs/coreapi-dto/service/sysOptions';
import FlexRow from '../../../../components/controls/FlexRow';
import { IOption, Select } from '../../../../components/selects/select';

interface IConnectionSettingsF3lloViewProps {
    plugin: IPluginSettings
}

interface IStoreRemains {
    isSendRemains: boolean;
    idGlobal: string
    name: string
}

interface IRemainsEnabled {
    idGlobal: string;
    name: string
    value: string;
}

interface IJson {
    Value: string
}

const columnFiltersRemainsTrue: IGridColumnFilter = {
    "name": "isSendRemains",
    "value": "true",
    "operator": "Eq"
}

const columnFiltersRemainsFalse: IGridColumnFilter = {
    "name": "isSendRemains",
    "value": "false",
    "operator": "Eq"
}

export const ConnectionSettingsF3lloView = (props: IConnectionSettingsF3lloViewProps) => {
    const appContext = useAppContext();
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const baseT = (value: string) => t('directory.contractors.' + value);

    const storeDP = new StoreDataProvider(appContext.coreApiService);
    const authDataDP = new AuthDataDataProvider(appContext.coreApiService);
    const sysOptionsDP = new SysOptionsDataProvider(appContext.coreApiService);

    const [connectionData, setConnectionData] = useState<IAuthDataViewDTO>({
        serviceName: 'F3LLO',
        appName: 'F3TailWeb',
        clientId: '',
        url: '',
        isEnabled: false,
        idGlobal: ''
    })

    const [lgotaGCData, setLgotaGCData] = useState<IAuthDataViewDTO>({
        serviceName: 'LgotaGC',
        appName: 'F3TailWeb',
        clientId: '',
        url: '',
        isEnabled: false,
        idGlobal: ''
    })

    const [lgotaGCRemainsData, setLgotaGCRemainsData] = useState<IAuthDataViewDTO>({
        serviceName: 'LgotaGCRemains',
        appName: 'F3TailWeb',
        clientId: '',
        url: '',
        isEnabled: false,
        idGlobal: ''
    })
    
    const [data, setData] = useState<ISysOptionsDTO>({} as ISysOptionsDTO)
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const [store, setStore] = useState<IStoreRemains[]>([]);
    const [storeTotalCount, setStoreTotalCount] = useState<number>(0);
    const [selectedItem, setSelectedItem] = useState<IGridRow | undefined>(undefined);

    const defaultProviderOption = { displayName: "Выберите поставщика", value: "", hidden: true } as IOption;
    const [currentOption, setCurrentOption] = useState<IOption>();
    const [providerData, setProviderData] = useState<ISysOptionsDTO>({} as ISysOptionsDTO)    

    const getServiceSettings = () => {
        setSelectedItem(undefined);

        authDataDP.getServiceName(connectionData.serviceName, (data) => {
            if (data.respType === 'isCompleted') {
                setConnectionData({
                    serviceName: 'F3LLO',
                    appName: 'F3TailWeb',
                    clientId: data?.data?.clientId || connectionData.clientId,
                    url: data?.data?.url || connectionData.url,
                    isEnabled: data?.data?.isEnabled || connectionData.isEnabled,
                    idGlobal: data?.data?.idGlobal || connectionData.idGlobal
                })
            }
        })
        
        authDataDP.getServiceName(lgotaGCData.serviceName, (data) => {
            if (data.respType === 'isCompleted') {
                setLgotaGCData({
                    serviceName: 'LgotaGC',
                    appName: 'F3TailWeb',
                    clientId: data?.data?.clientId || lgotaGCData.clientId,
                    url: data?.data?.url || lgotaGCData.url,
                    isEnabled: data?.data?.isEnabled || lgotaGCData.isEnabled,
                    idGlobal: data?.data?.idGlobal || lgotaGCData.idGlobal
                })
            }
        })

        authDataDP.getServiceName(lgotaGCRemainsData.serviceName, (data) => {
            if (data.respType === 'isCompleted') {
                setLgotaGCRemainsData({
                    serviceName: 'LgotaGCRemains',
                    appName: 'F3TailWeb',
                    clientId: data?.data?.clientId || lgotaGCRemainsData.clientId,
                    url: data?.data?.url || lgotaGCRemainsData.url,
                    isEnabled: data?.data?.isEnabled || lgotaGCRemainsData.isEnabled,
                    idGlobal: data?.data?.idGlobal || lgotaGCRemainsData.idGlobal
                })
            }
        })

        sysOptionsDP.getByName('GosContractRemainsEnabled', (e) => setData(e as ISysOptionsDTO))
    }

    const getProviderOption = () => {
        sysOptionsDP.getByName('SoapProvider', (e) => {
            setProviderData(e as ISysOptionsDTO)

            if(e?.value !== ''){
                setCurrentOption({ displayName: e?.displayValue as string, value: e?.value })
            }
        })
    }

    const getStore = () => {
        setSelectedItem(undefined);
        setLoadingStatus(LoadingStatus.InProcess);


        storeDP.getView({ ...gridFilter, columnFilters: [...gridFilter.columnFilters, columnFiltersRemainsTrue] }, (data, totalCount) => {
            if (totalCount > 0) {

                setStore(data.map(el => ({
                    idGlobal: el.idGlobal,
                    name: el.name,
                    isSendRemains: el.isSendRemains
                })))

                setStoreTotalCount(totalCount);
                setLoadingStatus(LoadingStatus.Completed)
            } else {
                setStore([]);
                setStoreTotalCount(0);
                setLoadingStatus(LoadingStatus.NoData);
            }
        })
    }

    const saveSettings = () => {
        if (connectionData.idGlobal) {
            authDataDP.update(connectionData.idGlobal as string, connectionData)
        } else {
            const { idGlobal, ...newData } = connectionData;
            authDataDP.create(newData, (newIdGlobal) => {
                setConnectionData(prev => ({ ...prev, idGlobal: newIdGlobal }))
            })
        }

        if (lgotaGCData.idGlobal) {
            authDataDP.update(lgotaGCData.idGlobal as string, lgotaGCData)
        } else {
            const { idGlobal, ...newData } = lgotaGCData;
            authDataDP.create(newData, (newIdGlobal) => {
                setLgotaGCData(prev => ({ ...prev, idGlobal: newIdGlobal }))
            })
        }

        if (lgotaGCRemainsData.idGlobal) {
            authDataDP.update(lgotaGCRemainsData.idGlobal as string, lgotaGCRemainsData)
        } else {
            const { idGlobal, ...newData } = lgotaGCRemainsData;
            authDataDP.create(newData, (newIdGlobal) => {
                setLgotaGCRemainsData(prev => ({ ...prev, idGlobal: newIdGlobal }))
            })
        }

        sysOptionsDP.update(data.idGlobal, data)
        
        sysOptionsDP.update(providerData.idGlobal, providerData)
    }

    const getValue = () => {
        if (!data?.jsonData) return undefined
        let obj: IJson = JSON.parse(data?.jsonData);
        return obj.Value
    }

    const onChangeInputs = (value: string | number | boolean, name: string) => {
        if (currentOption?.value == 'F3LLO'){
            setConnectionData(prev => ({ ...prev, [name]: value }));
        }
        if (currentOption?.value == 'Lgota'){
            setLgotaGCData(prev => ({ ...prev, [name]: value }));
            setLgotaGCRemainsData(prev => ({ ...prev, [name]: value }));
        }
    }

    const updateStoreRemains = (entities: IStoreRemains[]) => {

        const updateDataRemains: IStoreSendRemains = {
            setIsSendRemains: entities.map(el => ({ idStoreGlobal: el.idGlobal, isSendRemains: el.isSendRemains })) as IStoreSendRemain[]
        }

        storeDP.setIsSendRemains(updateDataRemains, (data) => {
            dispatchGridFilter({ type: "deleteColumnFilter", payload: 'name' });//Удаление фильтра для корректной работы.
        })
    }

    useEffect(() => {
        getProviderOption();
        getServiceSettings();
        getStore();
    }, [])

    // При работе с таблицей и запросами.
    const firstRender = useRef<boolean>(false);
    useEffect(() => {
        if (firstRender.current) {
            getStore();
        }
        firstRender.current = true;
    }, [gridFilter])

    // Для поиска склада.
    const [searchStore, setSearchStore] = useState<string>('');
    const handleSubmit = (event) => {
        event.preventDefault();
        getSearchStore(searchStore ? [{ name: "name", operator: "Like", value: `${searchStore}%` }] : []);
        setSearchStore('');
    };
    // Поиск склада.
    const getSearchStore = (filters: IGridColumnFilter[] = []) => {
        dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: 1 } });//Принудительно указываем страницу для корректного отображения.
        dispatchGridFilter({ type: "newColumnFilters", payload: [...filters] })
    }

    return (
        <PluginWrapper>
            <div>
                <Select
                    defaultOption={defaultProviderOption}
                    value={currentOption}
                    onSelect={(option) => {
                        if (currentOption !== option) {
                            setCurrentOption(option)
                            setProviderData({
                                ...providerData,
                                value: option.value,
                                displayValue: option.displayName                                
                            })
                        }
                    }}
                    options={[
                        defaultProviderOption,
                        { displayName: "F3 ЛЛО", value: "F3LLO" },
                        { displayName: "Льгота", value: "Lgota" },
                    ]}
                />
                <TextInput
                    disabled={currentOption?.value == 'Lgota'}
                    inline
                    value={connectionData.url}
                    label={baseT('urlF3LLO')}
                    onChange={(value) => onChangeInputs(value, 'url')}
                />
                <TextInput
                    disabled={currentOption?.value == 'F3LLO'}
                    inline
                    value={lgotaGCData.url}
                    label={baseT('urlLgotaGC')}
                    onChange={(value) => setLgotaGCData(prev => ({ ...prev, url: value }))}
                />
                <TextInput
                    disabled={currentOption?.value == 'F3LLO'}
                    inline
                    value={lgotaGCRemainsData.url}
                    label={baseT('urlLgotaGCRemains')}
                    onChange={(value) => setLgotaGCRemainsData(prev => ({ ...prev, url: value }))}
                />
                <TextInput
                    inline
                    value={connectionData.clientId}
                    label={baseT('clientId')}
                    onChange={(value) => onChangeInputs(value, 'clientId')}
                />
                <FlexRow>
                <CheckBox
                    className={styles.checkboxIsEnabled}
                    id='gosContractIsEnabled'
                    defaultChecked={connectionData.isEnabled}
                    label={'Обмен госконтрактами'}
                    onChanged={(value) => onChangeInputs(value, 'isEnabled')}
                />
                <CheckBox
                    className={styles.checkboxIsEnabled}
                    id='gosContractRemainsIsEnabled'
                    defaultChecked={Boolean(getValue())}
                    label={'Обмен остатками'}
                    onChanged={() => {
                        let val: boolean
                        val = !Boolean(getValue())
                        setData({
                          ...data,
                          jsonData: JSON.stringify({ Value: val }),
                          value: String(val)
                        })
                    }}
                />
                </FlexRow>
            </div>
            <div className={styles.panelAndSelectorWrapper}>
                <div>
                    <BaseCommandsPanel groups={[
                        [
                            {
                                iconButton: <Tooltip title="Удалить позицию">
                                    <Delete2Button sizeVariant="mini" colorVariant='danger' onClick={() => {

                                        if (selectedItem) {
                                            updateStoreRemains(store.map(el => ({ ...el, isSendRemains: el.idGlobal === selectedItem.idGlobal ? false : el.isSendRemains })))
                                        }

                                    }}
                                        disabled={selectedItem ? false : true} />
                                </Tooltip>
                            },
                        ]
                    ]}
                    />
                </div>
                <div className={styles.panelAndSelectorWrapper_selector}>
                    <GridMultipleSelectorInputV2
                        inline
                        label={"Склады"}//"Значение"
                        id={uuidv4()}
                        gridFilter={{ ...gridFilter, columnFilters: [...gridFilter.columnFilters, columnFiltersRemainsFalse] }}
                        selectorModalJsx={StoreSelectorModal}
                        switchOnchange
                        onSelect={(entities: IEntitySimpleDTO[]) => {
                            const newStores = [...store];
                            const newEntities = entities.map(el => ({ ...el, name: el.displayName, isSendRemains: true }));

                            const isItemPresent = (itemToCheck, array) =>
                                array.some(item => item.idGlobal === itemToCheck.idGlobal);

                            const updatedStores = newEntities.reduce((acc, item) => {
                                if (!isItemPresent(item, acc)) {
                                    acc.push(item);
                                }
                                return acc;
                            }, newStores);

                            updateStoreRemains(updatedStores);
                        }}
                        onClear={() => {
                        }}
                    />
                </div>
            </div>
            <form onSubmit={handleSubmit}>
                <div className={styles.searchForm}>
                    <TextInput
                        className={styles.searchForm_textInput}
                        inline label="Поиск добавленного склада:"
                        value={searchStore} 
                        onChange={setSearchStore}
                    />
                    <Button
                        className={styles.searchForm_searchButton}
                        buttonType="submit"
                        variant={'primary'}
                    >
                        Поиск...
                    </Button>
                </div>
            </form>
            <div className={styles.gridWrapper}>
                <DefaultGrid
                    showQuantity
                    clsGridWrapper={styles.gridWrapper_changeHeightGridWrapper}
                    gridId={'grid'}
                    filter={gridFilter}
                    plugin={ConnectionSettingsF3lloPlugin}
                    data={store}
                    totalCount={storeTotalCount}
                    selectedItem={selectedItem}
                    onSelect={(row) => {
                        setSelectedItem(row ? row : undefined)
                    }}
                    loadingStatus={loadingStatus}
                    setLoadingStatus={setLoadingStatus}
                    selectedItems={[]}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                    hiddenPagination={{ hiddenNumberPage: true, hiddenCountRow: true }} //show pagination
                />
            </div>
                <Button className={styles.saveSettingsBtn} variant="primary" onClick={saveSettings}>Сохранить</Button>
        </PluginWrapper >
    )
}